// Subdomain is semantically different from TenantSlug:
// it identifies a site (not the tenant workspace) and has its own reserved list.
const RESERVED = new Set(['www', 'app', 'api', 'admin', 'mail', 'support', 'help', 'brix', 'static', 'cdn', 'blog'])

export class Subdomain {
  private constructor(private readonly value: string) {}

  static from(raw: string): Subdomain {
    const normalised = raw
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')

    if (normalised.length < 3)  throw new Error(`Subdomain "${raw}" must be at least 3 characters`)
    if (normalised.length > 48) throw new Error(`Subdomain "${raw}" must be at most 48 characters`)
    if (RESERVED.has(normalised)) throw new Error(`"${normalised}" is a reserved subdomain`)

    return new Subdomain(normalised)
  }

  toString(): string { return this.value }
  equals(other: Subdomain): boolean { return this.value === other.value }
}
